import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HeaderSite from './Components/HeaderSite';
import FooterSite from './Components/FooterSite';

import IndexSite from './Components/IndexSite';
import React ,{ useState } from "react";



import TurnosSite from './Components/TurnosSites';
import TelemedicinaSites from './Components/TelemedicinaSites';
import WifiSites from './Components/WifiSites';
import ChatSites from './Components/ChatSites';
import ActividadesSites from './Components/ActividadesSites';
import AgendaSites from './Components/AgendaSites';
import EstudiosSites from './Components/EstudiosSites';
import EmergenciasSites from './Components/EmergenciasSites';
import CredencialSites from './Components/CredencialSites';
import BeneficiosSites from './Components/BeneficiosSites';
import EstacionamientoSites from './Components/EstacionamientoSites';
import LoginSite from './Components/LoginSite';
import TurnosDocumentacion from './Components/TurnosDocumentacion';
import TurnosSalud from './Components/TurnosSalud';
import TurnosAntecedentes from './Components/TurnosAntecedentes';
import TurnosZoonosisMenu from './Components/TurnosZoonozisMenu';
import TurnosZoonosis from './Components/TurnosZoonosis';
import TurnosLicenciasMenu from './Components/TurnosLicenciasMenu';
import TurnosLicencias from './Components/TurnosLicencias';
import "./Components/BodySite.css";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoMapas from './Components/Estacionamientos/EstacionamientoMapas';
import EstacionamientoPatente from './Components/Estacionamientos/EstacionamientoPatente';
import EstacionamientoLugar from './Components/Estacionamientos/EstacionamientoLugar';
import EstacionamientoInicio from './Components/Estacionamientos/EstacionamientoInicio';
import EstacionamientoFin from './Components/Estacionamientos/EstacionamientoFin';
import BotoneraCredito from './Components/Estacionamientos/BotoneraCredito';
import BotoneraPuntosCarga from './Components/Estacionamientos/BotoneraPuntosCarga';
import BotoneraGratuitos from './Components/Estacionamientos/BotoneraGratuitos';
import BotoneraInfoGral from './Components/Estacionamientos/BotoneraInfoGral';
import EPagosSites from './Components/EPagosSites';
import TurnosDocumentacionMenu from './Components/TurnosDocumentacionMenu';
import TurnosZoonosisMenuVillaRosa from './Components/TurnosZoonozisMenuVillaRosa';
import TurnosZoonosisMenuDerqui from './Components/TurnosZoonozisMenuDerqui';
import TurnosZoonosisMenuDelViso from './Components/TurnosZoonozisMenuDelViso';
import TurnosZoonosisMenuPilar from './Components/TurnosZoonozisMenuPilar';
import MiniFooterSite from './Components/MiniFooterSite';
import MiCuentaSites from './Components/MiCuentaSites';
import WifiSitesFilter from './Components/WifiSitesFilter';
import EstacionamientoActivate from './Components/EstacionamientoActivate';
import EstacionamientoEPagos from './Components/Estacionamientos/EstacionamientoEPagos';
import EstacionamientoPagoOk from './Components/Estacionamientos/EstacionamientoPagoOk';
import EstacionamientoPagoError from './Components/Estacionamientos/EstacionamientoPagoError';
import EstacionamientoError from './Components/Estacionamientos/EstacionamientoError';
import TelemedicinaView from './Components/TelemedicinaView';
import ActividadesDetalle from './Components/ActividadesDetalle';
import ActividadesIframe from './Components/ActividadesIframe';
import TramitesCancelaCites from './Components/TramitesCancelaSites';
import TramitesCancelaView from './Components/TramitesCancelaView';
import MisTurnosSites from './Components/MisTurnosSites';
import TurnosSaludMenu from './Components/TurnosSaludMenu';
import TurnosVacunacionMenu from './Components/TurnosVacunacionMenu';
import TurnosTelemedicinaMenu from './Components/TurnosTelemedicinaMenu';
import TurnosVacunacion from './Components/TurnosVacunacion';
import TurnosTelemedicina from './Components/TurnosTelemedicina';
import EstacionamientoPpal from './Components/EstacionamientoPpal';
import EstacionamientoDonde from './Components/EstacionamientoDonde';
import BotoneraGratuitosBis from './Components/Estacionamientos/BotoneraGratuitosBis';
import CredencialSitesBis from './Components/CredencialSitesBis';
import EstacionamientoMapasBis from './Components/Estacionamientos/EstacionamientoMapasBis';
import TurnosDocumentacionMenu2 from './Components/TurnosDocumentacionMenu2';
import TurnosZoonosisMenuContinuar from './Components/TurnosZoonozisContinuar';
import TurnosLicenciasMenuContinuar from './Components/TurnosLicenciasMenuContinuar';
//import EmergenciasBotones from './Components/EmergenciasBotones';

function App() {

  
  const [screenD, setScreenPart] = useState("Index");
 
  return (
    
   <div>

<HeaderSite/>
  <Router>
    <Routes>
      <Route path="/" element={<><IndexSite/><FooterSite/></>}/>
      <Route path="/chat" element={<ChatSites/>}/>
      <Route path="/turnos" element={<><TurnosSite/><FooterSite/></>}/>
      <Route path="/telemedicina" element={<><TelemedicinaSites/><FooterSite/></>}/>
      <Route path="/medicina" element={<><TelemedicinaSites/><FooterSite/></>}/>
      <Route path="/wifi" element={<><WifiSites/><FooterSite/></>}/>
      <Route path="/wififilter" element={<><WifiSitesFilter/><FooterSite/></>}/>
      <Route path="/actividades" element={<><ActividadesSites/><FooterSite/></>}/>
      <Route path="/agenda" element={<><AgendaSites/><FooterSite/></>}/>
      <Route path="/estudios" element={<><EstudiosSites/><FooterSite/></>}/>
      <Route path="/emergencias" element={<><EmergenciasSites/><FooterSite/></>}/>
      <Route path="/credencial" element={<><CredencialSites/><FooterSite/></>}/>
      <Route path="/beneficios" element={<><BeneficiosSites/><FooterSite/></>}/>
      <Route path="/estacionamiento" element={<><EstacionamientoSites/><FooterSite/></>}/>
      <Route path="/login" element={<IndexSite/>}/>
      <Route path="/log_in" element={<LoginSite/>}/>
      <Route path="/turnosdocumentacion" element={<><TurnosDocumentacion/><FooterSite/></>}/>
      <Route path="/turnossalud" element={<><TurnosSalud/><FooterSite/></>}/>
      <Route path="/turnosantecedentes" element={<><TurnosAntecedentes/><FooterSite/></>}/>
      <Route path="/turnoszoonosismenu" element={<><TurnosZoonosisMenu/><FooterSite/></>}/>
      <Route path="/turnoszoonosismenuvillarosa" element={<><TurnosZoonosisMenuVillaRosa/><FooterSite/></>}/>
      <Route path="/turnoszoonosismenuderqui" element={<><TurnosZoonosisMenuDerqui/><FooterSite/></>}/>
      <Route path="/turnoszoonosismenudelviso" element={<><TurnosZoonosisMenuDelViso/><FooterSite/></>}/>
      <Route path="/turnoszoonosismenupilar" element={<><TurnosZoonosisMenuPilar/><FooterSite/></>}/>
      <Route path="/turnoszoonosis" element={<><TurnosZoonosis/><FooterSite/></>}/>
      <Route path="/turnoslicenciasmenu" element={<><TurnosLicenciasMenu/><FooterSite/></>}/>
      <Route path="/turnoslicencias" element={<><TurnosLicencias/><FooterSite/></>}/>
      <Route path="/turnosdocumentacionmenu" element={<><TurnosDocumentacionMenu/><FooterSite/></>}/>
      <Route path="/estacionamientoactivate" element={<><EstacionamientoActivate/><FooterSite/></>}/>
      <Route path="/estacionamientomapas" element={<><EstacionamientoMapas/></>}/>
      <Route path="/estacionamientopatente" element={<><EstacionamientoPatente/><MiniFooterSite/></>}/>
      <Route path="/estacionamientolugar" element={<><EstacionamientoLugar/><MiniFooterSite/></>}/>
      <Route path="/estacionamientoinicio" element={<><EstacionamientoInicio/></>}/>
      <Route path="/estacionamientofin" element={<><EstacionamientoFin/></>}/>
      <Route path="/botoneracredito" element={<><BotoneraCredito/><FooterSite/></>}/>
      <Route path="/botonerapuntoscarga" element={<><BotoneraPuntosCarga/><FooterSite/></>}/>
      <Route path="/botoneragratuitos" element={<><BotoneraGratuitos/><FooterSite/></>}/>
      <Route path="/botonerainfogral" element={<><BotoneraInfoGral/><FooterSite/></>}/>
      <Route path="/epagos" element={<><EPagosSites/><FooterSite/></>}/>
      <Route path="/micuenta" element={<><MiCuentaSites/><FooterSite/></>}/>
      <Route path="/estpagos" element={<><EstacionamientoEPagos/><FooterSite/></>}/>
      <Route path="/estacionamientopagook" element={<><EstacionamientoPagoOk/><FooterSite/></>}/>
      <Route path="/estacionamientopagoerror" element={<><EstacionamientoPagoError/><FooterSite/></>}/>
      <Route path="/estacionamientoerror" element={<><EstacionamientoError/><FooterSite/></>}/>

      <Route path="/telemedicinaview" element={<><TelemedicinaView/><FooterSite/></>}/>
      <Route path="/actividaddetalle" element={<><ActividadesDetalle/><FooterSite/></>}/>
      <Route path="/actividadiframe" element={<><ActividadesIframe/><FooterSite/></>}/>
      <Route path="/tramitescancela" element={<><TramitesCancelaCites/><FooterSite/></>}/>
      <Route path="/misturnoslista" element={<><MisTurnosSites/><FooterSite/></>}/>
      <Route path="/tramitescancelaview" element={<><TramitesCancelaView/><FooterSite/></>}/>
      <Route path="/turnossaludmenu" element={<><TurnosSaludMenu/><FooterSite/></>}/>
      <Route path="/turnosvacunacionmenu" element={<><TurnosVacunacionMenu/><FooterSite/></>}/>
      <Route path="/turnostelemedicinamenu" element={<><TurnosTelemedicinaMenu/><FooterSite/></>}/>
      <Route path="/estacionamientoppal" element={<><EstacionamientoPpal/><FooterSite/></>}/>
      <Route path="/estacionamientodonde" element={<><EstacionamientoDonde/><FooterSite/></>}/>
      <Route path="/turnosvacunacion" element={<><TurnosVacunacion/><FooterSite/></>}/>
      <Route path="/turnostelemedicina" element={<><TurnosTelemedicina/><FooterSite/></>}/>
      <Route path="/botoneragratuitosbis" element={<><BotoneraGratuitosBis/><FooterSite/></>}/>
      <Route path="/credencialbis" element={<><CredencialSitesBis/><FooterSite/></>}/>
      <Route path="/estacionamientomapasbis" element={<><EstacionamientoMapasBis/></>}/>
      <Route path="/turnosdocumentacionmenu2" element={<><TurnosDocumentacionMenu2/></>}/>
      <Route path="/turnoszoonoziscontinuar" element={<><TurnosZoonosisMenuContinuar/></>}/>
      <Route path="/turnoslicenciasmenucontinuar" element={<><TurnosLicenciasMenuContinuar/></>}/>



     {/*  <Route path="/emergenciasbotones" element={<><EmergenciasBotones/><FooterSite/></>}/>*/}
    </Routes>
    </Router>
    


       
     
    </div>

  
   
  
  );
}

export default App;
